import { render } from "./App.vue?vue&type=template&id=d08ed2b0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d08ed2b0&lang=less"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__